<template>
    <div
        :class="{ relative: isLoading }"
        :data-component="$options.name"
    >
        <div
            v-if="isLoading"
            class="absolute duration-300 w-full h-full bg-white bg-opacity-90 z-overlay-canvas"
        >
            <cs-loading-spinner class="top-[275px]">
                <p class="whitespace-nowrap">Deine Ergebnisse werden aktualisiert</p>
            </cs-loading-spinner>
        </div>
        <div ref="elList">
            <div
                v-for="(item, index) in items"
                :key="item.exposeeId"
            >
                <template v-if="adSlotDisturber.has(index)">
                    <ms-disturber
                        v-for="disturber in adSlotDisturber.get()"
                        :key="`${disturber.cmsId}-${index}`"
                        :cms-content="disturber"
                        :data-disturber="index"
                        class="my-10 screen-m:my-20"
                    />
                </template>
                <ms-mail-agent-banner
                    v-if="hasMailAgentForIndex(index)"
                    :key="`mail-agent-${index}`"
                    :trackingVariant="MailAgentTrackingVariant.LIST"
                    :privacyPoliceUrl="privacyPoliceUrl"
                    :data-disturber="`mailAgent`"
                    class="shadow mb-16 screen-m:mt-20 screen-m:mb-20"
                />
                <div
                    v-if="isFirstPartnerItem(index, item.ownInventory)"
                    :key="`partner-${index}`"
                    class="mb-16 mt-40 py-8 px-16 bg-[#ffeb99] rounded-10 justify-between flex"
                    :data-separator="index"
                    data-test-id="immoweltSeperator"
                >
                    <p class="text-text-l font-bold content-center">In Kooperation mit:</p>
                    <ms-immowelt-badge />
                </div>
                <div :ref="index === 0 ? 'elFirstItem' : null">
                    <ms-result-list-item
                        :item="item"
                        :currentUrl="currentUrl"
                        :privacyManagerId="privacyManagerId"
                        :parentComponent="data.parentComponent"
                    />
                </div>
            </div>
        </div>
        <cs-linear-pagination
            v-if="resultListState.showPagination"
            class="pt-30 mb-32 border-t border-1 border-wildsand"
            :current="resultListState.currentPage"
            :last="resultListState.totalPages"
            @update:current="updatePageInStore"
        />
        <ms-safety-instructions v-if="hasItems()" />
        <div
            v-else
            class="flex flex-col items-center mt-16 mx-16 mb-56"
        >
            <ms-empty-result-list-svg class="mb-16" />
            <ms-headline
                type="h3"
                class="mb-8"
                :isSpan="true"
                >Keine Ergebnisse</ms-headline
            >
            <div
                class="text-text-l text-center mb-24 w-auto screen-m:w-[534px] screen-l:w-[607px] screen-xxl:w-[627px]"
            >
                <p class="mb-24">
                    {{ data.noResultsText }}
                </p>
                <p>
                    Alternativ kannst du dir diese Suche abonnieren und wirst bei passenden Immobilienangeboten
                    benachrichtigt.
                </p>
            </div>
            <cs-primary-button
                class="w-full screen-m:w-auto screen-m:shrink-0"
                :isCentered="true"
                @click="openModal"
            >
                <template #icon> <ms-bell /></template>
                <template #default>Suche abonnieren</template>
            </cs-primary-button>
        </div>
        <ms-mail-agent-modal
            :isVisible="modalIsVisible"
            :trackingVariant="MailAgentTrackingVariant.NO_RESULT"
            @closeModal="closeModal"
        />
    </div>
</template>
<script lang="ts" src="./MsResultList.ts" />
